import { render, staticRenderFns } from "./tradition_energy_manage.vue?vue&type=template&id=18ac15a8&"
import script from "./tradition_energy_manage.vue?vue&type=script&lang=js&"
export * from "./tradition_energy_manage.vue?vue&type=script&lang=js&"
import style0 from "./tradition_energy_manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports